import { useEffect, useState } from 'react';
import { PlansAPI } from '../../../api/payments/plans/api';

const PAGE_SIZE = 100; // mesmo default de PlansAPI.list
const MAX_PAGES = 20; // trava de segurança contra paginação sem fim

// Preenche `found` com os `ids` ainda pendentes achados em PlansAPI.list(active),
// página a página; para ao resolver todos ou quando a página vem incompleta.
async function findInList(active, ids, found, isCancelled) {
  for (
    let page = 0;
    page < MAX_PAGES && !isCancelled() && ids.some((id) => !found[id]);
    page += 1
  ) {
    const response = await PlansAPI.list({
      page,
      limit: PAGE_SIZE,
      active,
    }).catch(() => null);
    const content = response?.data?.content ?? [];
    content.forEach((plan) => {
      if (plan.name && ids.includes(String(plan.id)) && !found[plan.id]) {
        found[plan.id] = plan;
      }
    });
    if (content.length < PAGE_SIZE) return;
  }
}

// Resolve cada planId referenciado por regras PLAN direto por id (inclui
// planos inativos ou fora da 1ª página do list, que filtra active=true e
// limit=100); devolve { [id]: plano }. Falha de um id não afeta os outros.
export function usePlansById(rules) {
  const [plansById, setPlansById] = useState({});

  // Chave estável: `rules` muda de identidade a cada render do pai.
  const planIdsKey = [
    ...new Set(
      rules
        .filter((rule) => rule.scope === 'PLAN' && rule.planId)
        .map((rule) => rule.planId),
    ),
  ]
    .sort()
    .join(',');

  useEffect(() => {
    if (!planIdsKey) return undefined;
    let cancelled = false;
    const ids = planIdsKey.split(',');
    const isCancelled = () => cancelled;
    (async () => {
      const found = {};
      const entries = await Promise.all(
        ids.map((id) =>
          PlansAPI.get(id)
            .then((response) => [id, response.data])
            .catch(() => [id, null]),
        ),
      );
      entries.forEach(([id, plan]) => {
        if (plan?.name) found[id] = plan;
      });
      // get por id falhou/veio sem nome: pagina as listas de ativos e depois
      // de inativos (mesmo caminho de Offers/details) até achar os pendentes.
      for (const active of [true, false]) {
        await findInList(active, ids, found, isCancelled);
      }
      if (!cancelled) setPlansById((prev) => ({ ...prev, ...found }));
    })();
    return () => {
      cancelled = true;
    };
  }, [planIdsKey]);

  return plansById;
}
